import './EmptyPlaceholder.css';

export const EmptyPlaceholder = () => {
	return <li className="text">Empty</li>;
};
